angular
  .module('fca-used')
  .component('leadForm', {
    templateUrl: 'app/lead-form/lead-form.html',
    controller: LeadFormController,
    controllerAs: 'leadForm',
    bindings: {
      vehicle: '<'
    }
  });

LeadFormController.$inject = ['$rootScope', '$window', '$state', '$translate', '$timeout', 'scroll', 'CONFIG', '$log', '$http', 'tagging'];

function LeadFormController($rootScope, $window, $state, $translate, $timeout, scroll, CONFIG, $log, $http, tagging) {
  var leadForm = this;
  leadForm.config = CONFIG;
  leadForm.sent = false;
  leadForm.errors = false;
  leadForm.submitted = false;
  leadForm.privacyTextAccordion = false;
  leadForm.privacyProfilationAccordion = false;
  leadForm.privacyMarketingAccordion = false;
  leadForm.privacyThirdPartyAccordion = false;
  leadForm.mobileRegex = '[3]{1,1}[0-9]{8,9}';
  leadForm.mobileMaxLenght = 10;
  switch (leadForm.config.market.id.toLowerCase()) {
    case 'it':
      leadForm.mobileRegex = '[3]{1,1}[0-9]{8,9}';
      leadForm.mobileMaxLenght = 10;
      break;
    case 'fr':
      leadForm.mobileRegex = '(((06)|(07))\\d{8})|((01)|(02)|(03)|(04)|(05)|(09))\\d{8}';
      leadForm.mobileMaxLenght = 10;
      break;
    case 'es':
      leadForm.mobileRegex = '[67][0-9]{8}';
      leadForm.mobileMaxLenght = 9;
      break;
    case 'at':
      leadForm.mobileRegex = '(^\\+43-(6)[4-9][0-9]-\\d{7,9})|(\\+43-___-_________)';
      break;
    case 'pt':
      leadForm.mobileRegex = '9[0-9]{8}';
      leadForm.mobileMaxLenght = 9;
      break;
    case 'be':
      leadForm.mobileRegex = '(^\\+32( 4)[6-9][0-9]{7})|(\\+32 4________)';
      break;
    case 'pl':
      leadForm.mobileRegex = '[67][0-9]{8}';
      leadForm.mobileMaxLenght = 9;
      break;
  }

  leadForm.mobileMask = null;
  leadForm.mobileMaskValue = null;
  switch (leadForm.config.market.id.toLowerCase()) {
    case 'at':
      leadForm.mobileMask = '+43-999-9999999?99';
      leadForm.mobileMaskValue = '+43';
      break;
    case 'be':
      leadForm.mobileMask = '+32 499999999';
      leadForm.mobileMaskValue = '+32';
      break;
  }

  leadForm.fields = {
    title: '',
    firstName: '',
    lastName: '',
    secondLastName: '',
    email: '',
    confirmEmail: '',
    mobileNumber: '',
    notes: '',
    privacyMarketing: '',
    privacyProfilation: '',
    privacyThirdParty: ''
  };

  leadForm.update = function (fields, isValid) {
    var m = new Date();
    var device = angular.isUndefined($window.digitalData) ? '' : $window.digitalData.page.pageInfo.sysEnv.toUpperCase();
    if (isValid) {
      var normalizedFields = {
        TITLE_PERSON: fields.title,
        nome: fields.firstName,
        cognome: fields.lastName + ' ' + fields.secondLastName,
        Email: fields.email,
        cellulare: fields.mobileNumber,
        comment: fields.notes + ' ' + $window.location.href.toString(),
        SpecifyPrivacy: 1,
        EXTENDEDPRIVACYALL: leadForm.config.market.id === 'it' ? fields.privacyMarketing : -1,
        MARKETING_MAIL1: leadForm.config.market.id === 'it' ? -1 : fields.privacyMarketing,
        MARKETING_POST1: -1,
        MARKETING_SMS1: leadForm.config.market.id === 'it' ? -1 : fields.privacyMarketing,
        MARKETING_PHONE1: leadForm.config.market.id === 'it' ? -1 : fields.privacyMarketing,
        PRIVACYPROFILATION: fields.privacyProfilation,
        PRIVACYTHIRDPARTY: fields.privacyThirdParty,
        DISCLAIMER: angular.isDefined(leadForm.config.leadform) && angular.isDefined(leadForm.config.leadform.disclaimerId) ? leadForm.config.leadform.disclaimerId : '',
        BUSAREA: 2,
        Country: leadForm.config.market.id,
        Brand: '99',
        OFFER: angular.isDefined(leadForm.config.leadform) && angular.isDefined(leadForm.config.leadform.offer) ? leadForm.config.leadform.offer : '',
        Market: leadForm.config.market.code,
        MODELDESCRIPTION: leadForm.vehicle.data.modelDescription || '',
        MODELCOMMERCIALCODE: leadForm.vehicle.data.modelCode || '',
        MODELVIN: leadForm.vehicle.data.vin || '',
        MODELPRICE: leadForm.vehicle.data.priceCurrent || '',
        NAME: leadForm.vehicle.data.dealerName || '',
        DEALERSINCOM: leadForm.vehicle.data.dealer.SINCOM || '',
        DEALERSITECODE: leadForm.vehicle.data.dealer.SITECODE || '',
        TYPE: 'RI',
        LEVEL1: 'WEB CORPORATE',
        LEVEL2: 'INVENTORY',
        LEVEL3: 'N_A',
        LEVEL4: 'BRAND',
        CAMPAIGN: angular.isDefined(leadForm.config.leadform) && angular.isDefined(leadForm.config.leadform.campaign) ? leadForm.config.leadform.campaign : '',
        Language: angular.isDefined(leadForm.config.leadform) && angular.isDefined(leadForm.config.leadform.language) ? leadForm.config.leadform.language : '',
        USEDDEVICE: device,
        ID_TIMESTAMP: m.getTime().toString() + leadForm.vehicle.data.dealer.SITECODE || '',
        PREVIOUS_URL: $window.document.referrer,
        elqFormName: 'ProdFcaUsedForm',
        formAddress: $window.location.href.toString()
      };

      var postParams = Object.keys(normalizedFields).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(normalizedFields[key]);
      }).join('&');
      var leadUrl = leadForm.config.leadform.postUrl;
      $http({
        method: 'POST',
        /*
        prod https://fe4211717564047d741171.pub.s50.sfmc-content.com/xuz5couy2vz
        stage https://fe4311717564047d741170.pub.s50.sfmc-content.com/3rs0iwl0znu
        */
        url: leadUrl,
        data: postParams,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        // eslint-disable-next-line func-names
      }).then(function successCallback(response) {
        $log.log('success');
        $log.log(response);
        leadForm.sent = true;
        if (response.data.result !== 'Success') {
          leadForm.errors = true;
        } else {
          var taggingOptions = {
            event: 'thankyou',
            thankYou: true
          };
          tagging.track(taggingOptions);
        }
        // eslint-disable-next-line func-names
      }, function errorCallback(response) {
        leadForm.sent = true;
        leadForm.errors = true;
        $log.log('error');
        $log.log(response);
      });
    }
  };
}

